import React from 'react';

const DismissIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" fill="white" />
    <path
      d="M12 2C17.5 2 22 6.5 22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2ZM20 12C20 7.6 16.4 4 12 4C10.2 4 8.5 4.6 7.1 5.7L18.3 16.9C19.4 15.5 20 13.8 20 12ZM12 20C13.8 20 15.5 19.4 16.9 18.3L5.7 7.1C4.6 8.5 4 10.2 4 12C4 16.4 7.6 20 12 20Z"
      fill="#7D878F"
    />
  </svg>
);

export default DismissIcon;
